import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/shared/coming-soon';

export const Route = createFileRoute('/app/inquiry/')({
  component: () => <ComingSoon product="inquiry" />,
});
